import { TeacherType } from '../../types/teacher-type';
import { TeacherOption } from '../types/teacher-opt.type';

export const TEACHER_OPTIONS: TeacherOption[] = [
  {
    value: TeacherType.NATIVE,
    isRecommended: false,
    details: {
      iconPath: '/images/native-teacher-icon.svg',
      title: 'oeapp.lconboarding.native.title',
      description: 'oeapp.lconboarding.native.description',
    },
  },
  {
    value: TeacherType.BILINGUAL,
    isRecommended: true,
    details: {
      iconPath: '/images/bilingual-teacher-icon.svg',
      title: 'oeapp.lconboarding.bilingual.title',
      description: 'oeapp.lconboarding.bilingual.description',
    },
  },
];



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/consts/teacher-options.ts